import { request } from 'utils/request';
import {
  IAuthorizationQuery,
  IInstallAppQuery,
  IAuthorization,
  IInstallApp,
  IDict,
} from './interface';
import env from '../../env';

export const api_host = env[process.env.REACT_APP_SECRET_API].api_host;

export const shopify_host = env[process.env.REACT_APP_SECRET_API].shopify_host;

export async function authorization(
  data: IAuthorizationQuery,
): Promise<IAuthorization> {
  return request(
    `${shopify_host}/Auth/Shopify/authorization`,
    {
      method: 'POST',
      data,
    },
    false,
  );
}

export async function installApp(data: IInstallAppQuery): Promise<IInstallApp> {
  return request(
    `${shopify_host}/Auth/Shopify/installApp`,
    {
      method: 'POST',
      data,
    },
    false,
  );
}

export async function getCollection(): Promise<IDict> {
  return request(`${api_host}/shopify/collection/all`, {
    method: 'POST',
  });
}

export async function getPlatform(): Promise<IDict> {
  return request(`${api_host}/trackify/pixel/platform/all`, {
    method: 'GET',
  });
}
